import { MrbBaseRouteStore } from "mrb/core";
import { PortalAnalyticsService } from "common/services";

class ConnectedDevicesActivityRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(PortalAnalyticsService);
    }

    async getConnectedDevicesActivity(filter, abortController) {
        const response = await this.service.getConnectedDevicesActivity(filter, abortController);
        return response.data;
    }

    async getConnectedDevicesSummary(filter, abortController) {
        const response = await this.service.getConnectedDevicesSummary(filter, abortController);
        return response.data;
    }
}

export default ConnectedDevicesActivityRouteStore;
